import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  //inject services
  constructor(private afs: AngularFireStorage) { }

  //upload a file
  upload(strFilename, file) {
    this.afs.upload(strFilename, file);  
  }

  //find the specified file
  find(strFile): Observable<any> {
    return this.afs.ref(strFile).getDownloadURL();
  }

  //delete the specified file
  delete(strFile) {
    this.afs.ref(strFile).delete();
  }
}
